// extracted by mini-css-extract-plugin
export default {"error":"uB7JU-d588jEOELUVyGshw==","icon":"iuGecezEvPVqb5iegrG2Lg=="};